import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import { fetchCategories } from '../utils/categories';
import './CategoryCardView.css';

const CategoryCardView = ({ onCardClick }) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    fetchCategories()
      .then((rows) => {
        if (!cancelled) setCategories(rows);
      })
      .catch((err) => {
        console.error('Error loading categories:', err);
        if (!cancelled) setCategories([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) {
    return <div className="category-card-view category-loading">Loading categories…</div>;
  }

  if (!categories.length) {
    return <div className="category-card-view category-loading">No categories available.</div>;
  }

  const slidesToShow = Math.min(6, categories.length);

  return (
    <div className="category-card-view">
      <Slider
        dots={false}
        infinite={categories.length > slidesToShow}
        speed={500}
        slidesToShow={slidesToShow}
        slidesToScroll={1}
        nextArrow={<SampleNextArrow />}
        prevArrow={<SamplePrevArrow />}
        arrows={categories.length > 1}
        responsive={[
          { breakpoint: 1280, settings: { slidesToShow: Math.min(5, categories.length) } },
          { breakpoint: 1024, settings: { slidesToShow: Math.min(4, categories.length) } },
          { breakpoint: 768, settings: { slidesToShow: Math.min(3, categories.length) } },
          { breakpoint: 600, settings: { slidesToShow: Math.min(2, categories.length) } },
        ]}
      >
        {categories.map((category) => (
          <div
            key={category.id}
            className="card"
            onClick={() => onCardClick(category.id)}
          >
            <img
              src={category.imageUrl}
              alt={category.name}
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = '/images/default.jpg';
              }}
            />
            <div className="card-title">{category.name}</div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

const arrowStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'rgba(255,255,255,0.85)',
  backdropFilter: 'blur(10px)',
  WebkitBackdropFilter: 'blur(10px)',
  border: '1px solid rgba(47,133,90,0.4)',
  width: '44px',
  height: '44px',
  borderRadius: '50%',
  zIndex: 5,
  color: '#15803d',
  fontSize: '20px',
  fontWeight: 700,
  boxShadow: '0 8px 22px rgba(15,94,41,0.18)',
  boxSizing: 'border-box',
};

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, ...arrowStyle }}
      onClick={onClick}
    >
      <span>&gt;</span>
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, ...arrowStyle }}
      onClick={onClick}
    >
      <span>&lt;</span>
    </div>
  );
}

export default CategoryCardView;
